import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout")(
    {
        component: () => <LeadLayout />,
        loader: ({ context: { t } }) => ({
            breadcrumb: t("pages.tool.structure.lead.title"),
        }),
    }
);

function LeadLayout() {
    return <Outlet />;
}
